export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Error"] = "Error";
    PaymentStatus["Success"] = "Success";
})(PaymentStatus || (PaymentStatus = {}));
